// ABOUTME: Floating admin-only button that turns the current page into a live visual editor.
// ABOUTME: Hidden for non-admins and inside the admin panel; lazy-loads the editing overlay on demand.

import { Suspense, lazy } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Pencil } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useLiveEditor } from '@/contexts/LiveEditorContext';

const LiveEditorOverlay = lazy(() => import('@/components/live-editor/LiveEditorOverlay'));

export const AdminQuickBar = () => {
  const { isAdmin } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();
  const { editing, setEditing } = useLiveEditor();

  // Editing mode is strictly admin-only and never shown inside the admin panel
  if (!isAdmin || location.pathname.startsWith('/admin')) return null;

  if (editing) {
    return (
      <Suspense fallback={null}>
        <LiveEditorOverlay pathname={location.pathname} onClose={() => setEditing(false)} />
      </Suspense>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-[9999]" data-live-editor-ui="true">
      <button
        onClick={() => setEditing(true)}
        aria-label={t('liveEditor.openButton', { defaultValue: 'Редактировать страницу' })}
        className="group flex items-center h-9 rounded-full shadow-lg border border-border bg-card text-foreground
          overflow-hidden transition-all duration-300 ease-in-out w-9 hover:w-52 hover:px-3 hover:gap-1.5"
      >
        <span className="flex items-center justify-center w-9 h-9 shrink-0">
          <Pencil className="h-4 w-4" />
        </span>
        <span className="text-sm font-medium whitespace-nowrap max-w-0 overflow-hidden opacity-0 group-hover:max-w-[200px] group-hover:opacity-100 transition-all duration-300">
          {t('liveEditor.openButton', { defaultValue: 'Редактировать страницу' })}
        </span>
      </button>
    </div>
  );
};
